import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Constants from "../../Constants/Constants";
import { toast } from "react-hot-toast";

export const uploadSpreadsheet = createAsyncThunk(
  "upload/spreadsheet",
  async (file: File, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append("spreadsheet", file);
    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/upload/spreadsheet`,
        formData
      );
      
      if (data?.success === true) {
        toast.success("Spreadsheet uploaded successfully");
      }
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        toast.error(err?.response?.data?.message);
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);
